import { Component, OnInit } from '@angular/core';
import { LicenceService } from '../licence/licence.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/shared/user/user.service';
import { AnalyticsService } from 'src/app/shared/analytics/analytics.service';

@Component({
  selector: 'app-licence',
  templateUrl: './licence.component.html',
  styleUrls: ['./licence.component.scss']
})
export class LicenceComponent implements OnInit {

  licencesData: any[];
  activeCountries: any[] = [];
  regionCodes: string[] = [];

  constructor(
    private licenceService: LicenceService,
    private userService: UserService,
    private route: ActivatedRoute,
    private analyticsService: AnalyticsService,
    private router: Router
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
    };
  }

  ngOnInit() {
    this.route.queryParams
    .subscribe(p => {
      if (p.regionCode) {
        this.regionCodes = this.regionCodes.concat(p.regionCode);
      } else {
        this.regionCodes = this.regionCodes.concat(this.userService.getRegions());
      }
      this.licenceService.getLicencesHome(this.regionCodes)
      .subscribe(data => {
        this.licencesData = data;
        // if(data && data.licences.length > 0){
        //   this.activeCountries.push(data.licences[0].countryCode);
        // }
      });
    });
  }

  toggleActiveRows(row: any) {
    this.analyticsService.pushEvent('toggleAccordion');
    const index = this.activeCountries.indexOf(row.countryCode);
    if ( index > -1 ) {
      this.activeCountries.splice(index, 1);
    } else {
      this.activeCountries.push(row.countryCode);
    }
  }

  isActiveRow(row: any) {
    return this.activeCountries.indexOf(row.countryCode) !== -1 ;
  }

  isBandGroupEmpty(row: any, bandGroup: any) {
    return row.bandGroups[bandGroup] == undefined ;
  }

}
